<template>
  <a-modal
    v-model:visible="visible"
    centered
    width="720px"
    title="Nueva importación"
    :footer="false"
    :mask-closable="false"
  >
    <div class="modal__body">
      <p class="text__center">
        Recuerda que, si es la primera vez que importarás datos a una nueva campaña, debes crear tus
        formatos en la <a @click="handleShowDrawer">sección de plantillas</a> de este módulo.
      </p>

      <section class="cards">
        <div
          class="card modal_button"
          :class="getClass(1)"
          id="import-modal-contacts-products-button"
          @click="handleSelectedProducts"
        >
          <img class="card__icon" src="@/app/imports/assets/user_plus_cart.png" alt="user" />
          <span class="card__title">Contactos o productos</span>
          <p class="card__description">
            Importa datos nuevos o actualiza existentes de tus contactos o productos direccionados.
            Recuerda primero crear tus formatos en la sección de plantillas de este módulo.
          </p>
        </div>

        <div class="card" :class="getClass(2)" @click="handleSelectedProcess">
          <img class="card__icon" src="@/app/imports/assets/folder_plus_add.png" alt="folder" />
          <span class="card__title">Procesos masivos</span>
          <p class="card__description">
            Importa datos personales de tus contactos como teléfonos, direcciones, etc. Además, haz
            procesos masivos como actualizaciones, asignaciones de usuarios, inactivaciones y más.
          </p>
        </div>
      </section>

      <p class="information">
        Para conocer más sobre importaciones,
        <a :href="DOCS_URL" target="_blank" rel="noopener noreferrer"> visita nuestro docs. </a>
      </p>
    </div>
  </a-modal>
</template>

<script>
import { defineComponent } from "vue";
import EventBus from "@/app/shared/utils/eventBus";
import { WorkspaceEvent } from "@/app/workspace/domain/events";

export default defineComponent({
  props: {
    modelValue: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    const DOCS_URL = `${import.meta.env.VITE_WEB_DOC}/crm/importaciones-1/`;

    return {
      selected: 0,
      disable: true,
      DOCS_URL: DOCS_URL,
    };
  },
  computed: {
    visible: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    visible(value) {
      if (value) this.selected = 0;
    },
  },
  methods: {
    getClass(type) {
      return { "card--selected": this.selected == type };
    },
    onClick(type) {
      this.selected = type;
      this.disable = false;
    },
    handleShowDrawer() {
      EventBus.$emit(WorkspaceEvent.DRAWER_TEMPLATE_OPEN);
      this.visible = false;
    },
    handleSelectedProducts() {
      this.$emit("onOpenModalProducts", true);
      this.visible = false;
    },
    handleSelectedProcess() {
      this.$emit("onOpenModalProcess", true);
      this.visible = false;
    },
  },
});
</script>

<style lang="sass" scoped>

.modal
  &__body
    padding-top: 16px
    display: flex
    flex-direction: column
    align-items: center

.cards
  display: flex
  margin-bottom: 12px

.card
  margin: 10px
  padding: 12px 20px
  color: $gray-8
  border-radius: 8px
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1)
  max-width: 200px
  height: 240px
  display: flex
  flex-direction: column
  align-items: center
  cursor: pointer
  box-sizing: content-box
  transition: box-shadow  0.3s
  border: 1px solid $white

  &:hover
    box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.1)
    border: 1px solid $blue-6
    transition: box-shadow  0.3s

  &--selected
    border: 1px solid $blue-6
    margin: 9px

  &__icon
    display: block
    height: 60px
    margin: 20px

  &__title
    font-weight: 600
    margin-bottom: 8px

  &__description
    font-size: 12px
    text-align: center

.text__center
  text-align: center

.information
  margin-top: 20px
</style>
